import React from 'react';
import { Button } from '@bynder/design-system';
import { Translate } from '@bynder/localization';
import { UploadType, useUploader } from '../../../../hooks/useUploader';
import { useGuideMutations } from '../../../../mutations/guides';
import { useGuideStore } from '../../../../stores/guideStore';
import { IconUpload } from '@bynder/icons';
interface Props {
  canUseUploader: boolean;
}

export const GuideCoverImageUploaderButton: React.FC<Props> = ({
  canUseUploader,
}) => {
  const { BynderUploader, handleClick, isConfirmed, isRegistered } =
    useUploader(UploadType.GuideCover);
  const activeGuideId = useGuideStore(s => s.activeGuideId);
  const { updateGuideCover } = useGuideMutations(activeGuideId);

  const onUploadCompleted = (mediaId: string) => {
    updateGuideCover.mutate({ mediaId });
  };

  return (
    <BynderUploader onUploadCompleted={onUploadCompleted}>
      <Button
        isLoading={isConfirmed || isRegistered}
        isDisabled={!canUseUploader || isConfirmed || isRegistered}
        icon={<IconUpload />}
        variant="secondary"
        isFullWidth
        onClick={handleClick}
      >
        <Translate id="PAGE_INSPECTOR.PERSONAL_UPLOAD" />
      </Button>
    </BynderUploader>
  );
};
